import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import CustomPieZoomChart from '../../../../../components/ui/charts/zoom/CustomPieZoomChart'

class StudentActivities extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    activities: PropTypes.object.isRequired,
    student: PropTypes.any.isRequired,
    isMobile: PropTypes.bool,
  }

  /**
   * @method render
   */
  render() {
    const { activities, student, isMobile } = this.props

    const pertinentActivities = activities[student._id]

    if (!pertinentActivities)
      return <h1>No Activities Yet by {student.fullName}</h1>

    const chartData = {
      values: pertinentActivities.map(item => ({
        name: item.taskTypeName,
        value: item.count,
      })),
    }

    return (
      <div className="card-body max-800 pb-0">
        <div className="row">
          <div className="col-md-5 pr-0">
            <h1 style={{ marginBottom: 5 }}>{student.fullName}</h1>
            <div>
              <h5 style={{ marginBottom: 5 }}>{student.email}</h5>
              <h5>
                Last Login:&nbsp;
                {moment(student.lastLogin).format('MMM Do YYYY')}
              </h5>
            </div>

            {student.interests && !isMobile && (
              <h5
                className="header-color"
                style={{ bottom: 0, position: 'relative', marginTop: 40 }}
              >
                <strong>Interest{student.interests.length > 1 && 's'}: </strong>
                {student.interests.map((interest, index) => {
                  if (student.interests.length < 2) {
                    return (
                      <span
                        key={interest}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {interest}
                      </span>
                    )
                  } else if (student.interests.length === index + 1) {
                    return (
                      <span key={interest}>
                        and{' '}
                        <span style={{ textTransform: 'capitalize' }}>
                          {interest}
                        </span>
                      </span>
                    )
                  } else {
                    return (
                      <span
                        key={interest}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {interest},&nbsp;
                      </span>
                    )
                  }
                })}
              </h5>
            )}
          </div>
          <div className="col-md-7">
            <h4 className="text-center mb-0">Student Activities</h4>
            <CustomPieZoomChart
              chartData={chartData}
              height={250}
              innerRadius={0.6}
              elementId="student-activites"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default StudentActivities



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/StudentActivities/StudentActivities.js